export const HOME_PATH = '/';
export const STAMPS_PATH = '/stamps';
export const INBOX_PATH = '/inbox';
export const OUTBOX_PATH = '/outbox';
